function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import _ from 'lodash/fp';

var fp = _.noConflict();

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  components: {
    Multiselect: Multiselect
  },
  props: {
    side: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    var categories = this.$ncsConfig.tags.categories;
    var levelToCategory = fp.groupBy(function (c) {
      return c.split('.')[0];
    })(categories); // Each level corresponds to a select in the view

    var levels = fp.keys(levelToCategory); // Some levels may be hidden. E.g.: In Feeling tag set some levels have always a 0 value.

    var visibleLevels = fp.difference(levels)(this.$ncsConfig.tags.hideLevels);
    return {
      categories: categories,
      levels: levels,
      visibleLevels: visibleLevels,
      levelToCategory: levelToCategory
    };
  },
  computed: {
    selected: {
      get: function get() {
        var value = this.$store.state.elements[this.side][this.index].tag.friendlyTagSelected;

        if (!value) {
          value = fp.transform(function (n) {
            return _defineProperty({}, n, null);
          })({})(this.levels);
          this.selected = value;
        }

        return value;
      },
      set: function set(value) {
        this.setTagAttr('friendlyTagSelected', value);
      }
    },
    availableOptions: {
      get: function get() {
        var value = this.$store.state.elements[this.side][this.index].tag.friendlyTagAvailable;

        if (!value) {
          value = this.$ncsConfig.tags.matrix;
          this.availableOptions = value;
        }

        return value;
      },
      set: function set(value) {
        this.setTagAttr('friendlyTagAvailable', value);
      }
    }
  },
  methods: {
    setTagAttr: function setTagAttr(name, value) {
      this.$store.commit('elements/setFieldAttr', {
        side: this.side,
        index: this.index,
        field: 'tag',
        attr: name,
        value: value
      });
    },
    reset: function reset() {
      this.availableOptions = this.$ncsConfig.tags.matrix;
      this.selected = fp.transform(function (n) {
        return _defineProperty({}, n, null);
      })({})(this.levels);
    },
    selectLevel: function selectLevel(name, value) {
      this.$set(this.selected, name, value);
      this.availableOptions = this.filterOptions(this.selected);
    },
    filterOptions: function filterOptions(selection) {
      var allSelected = fp.compact(fp.values(selection));

      var filterBySelection = function filterBySelection(rows, selection) {
        return fp.filter(function (r) {
          return r[selection.index] === selection.tag;
        })(rows);
      };

      return fp.reduce(filterBySelection)(this.$ncsConfig.tags.matrix)(allSelected);
    },
    options: function options(name) {
      var _this = this;

      // Apply all selected filters except the current one to get the possible selector options
      var availableOptionsForLevel = this.filterOptions(_objectSpread(_objectSpread({}, this.selected), {}, _defineProperty({}, name, null))); // Convert a level name, an index and a tag part to an option object

      var tagPartToOption = function tagPartToOption(c, i) {
        return function (part) {
          var label = _this.$tOr("tag.".concat(c.split('.').pop()), part, part);

          return {
            tag: part,
            index: i,
            label: label,
            id: "".concat(part, "-").concat(i, "-").concat(label)
          };
        };
      };

      var optionsForCategory = function optionsForCategory(category) {
        var index = fp.findIndex(fp.eq(category))(_this.categories); // From the list of possible tags...

        return fp.pipe(fp.map(fp.get(index)), // Get the tag part at the corresponding index
        fp.compact, // Remove nil values
        fp.uniq, // Remove duplicates
        fp.map(tagPartToOption(category, index)) // Convert to an object form to use it in the selector
        )(availableOptionsForLevel);
      }; // One level (selector) can have options from different categories


      var categoriesForLevel = this.levelToCategory[name];
      var options = fp.flatMap(optionsForCategory)(categoriesForLevel);
      return fp.sortBy(this.$ncsConfig.tags.sortBy)(options); // Sort by translated name
    }
  }
};